var map = {
	"./china.svg": 265,
	"./circle_black.svg": 969,
	"./circle_blue.svg": 970,
	"./cn.svg": 971,
	"./ellipse_black.svg": 972,
	"./forgotpassword.svg": 322,
	"./france.svg": 266,
	"./highlighted_yellow.svg": 973,
	"./icons/_info.svg": 974,
	"./icons/add_prod.svg": 269,
	"./icons/add_prodOLD.svg": 975,
	"./icons/ask.svg": 976,
	"./icons/facebook.svg": 37,
	"./icons/hatchef.svg": 51,
	"./icons/icone/_info.svg": 977,
	"./icons/icone/hatchef.svg": 978,
	"./icons/icone/info.svg": 979,
	"./icons/icone/play.svg": 980,
	"./icons/icone/plus.svg": 981,
	"./icons/icone/specs.svg": 982,
	"./icons/icone/world.svg": 983,
	"./icons/index-icon-bookmark.svg": 984,
	"./icons/index-icon.svg": 411,
	"./icons/info.svg": 52,
	"./icons/markers-SVG/ask.svg": 985,
	"./icons/markers-SVG/info.svg": 986,
	"./icons/markers-SVG/list.svg": 987,
	"./icons/markers-SVG/recipe.svg": 988,
	"./icons/markers-SVG/web.svg": 989,
	"./icons/play.svg": 46,
	"./icons/play_ip.svg": 990,
	"./icons/plus.svg": 49,
	"./icons/promo.svg": 45,
	"./icons/promo2.svg": 991,
	"./icons/promo3.svg": 992,
	"./icons/promo_10.svg": 993,
	"./icons/promo_classic.svg": 994,
	"./icons/remove_prod.svg": 270,
	"./icons/remove_prodOLD.svg": 995,
	"./icons/shop_list.svg": 271,
	"./icons/specs.svg": 44,
	"./icons/whatsapp.svg": 38,
	"./icons/world.svg": 40,
	"./logo.svg": 996
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;